module.exports = __webpack_public_path__ + "media/src/components/shared/loaders/img/spinner-white-55709624be22f051cf64f87ec9544bd8.gif";